import React from 'react'
import { updateObject } from 'helpers/objectHelpers'
import FormLanguage from 'components/forms/FormLanguage'
import FormTarget from 'components/forms/FormTarget'
import FormLink from 'components/forms/FormLink'

const ButtonContent = ({
  value,
  value: {
    text = {},
    link = '',
    target = '_self',
  },
  onChange,
}) => {
  const handleChange = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  return (
    <div>
      <FormLanguage
        value={text}
        onChange={(val) => handleChange(val, 'text')}
      />
      <FormLink
        value={link}
        onChange={(val) => handleChange(val, 'link')}
      />
      <FormTarget
        value={target}
        onChange={(val) => handleChange(val, 'target')}
      />
    </div>
  )
}

ButtonContent.propTypes = {}
ButtonContent.defaultProps = {}

export default ButtonContent



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/button/ButtonContent.js